<template>
    <div>

        <main role="main">

            <div class="container-fluid">

              <div class="row">
                <div class="col-md-12">
                  <a class="mt-3 mb-3 d-block" @click="$router.go(-1)">
                    <i class="fa fa-chevron-circle-left"></i> {{ $t('text.globals.back') }}
                  </a>
                </div>
              </div>

                <div class="row mt-2 mb-2">
                    <div class="col-md-12">

                        <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

                        <h3 class="mb-5">
                            {{this.$route.params.transactionGroup}}
                        </h3>

                        <div class="row mt-3 mb-3">

                            <div class="col-md-6">
                                <VueCtkDateTimePicker id="startTime" format="YYYY-MM-DDTHH:mm:ssZ" class="withLabel"
                                                      formatted="DD.MM.YYYY, HH:mm"
                                                      v-model="startTimestamp"
                                                      @input="updateTimes()"
                                                      :locale="$t('text.globals.datePickerLocale')"
                                                      :label="$t('text.apmPages.chooseDate')"
                                                      :button-now-translation="$t('text.globals.now')"
                                />
                            </div>

                            <div class="col-md-6">
                                <VueCtkDateTimePicker id="endTime" format="YYYY-MM-DDTHH:mm:ssZ" class="withLabel"
                                                      formatted="DD.MM.YYYY, HH:mm" v-model="endTimestamp"
                                                      @input="updateTimes()"
                                                      :locale="$t('text.globals.datePickerLocale')"
                                                      :label="$t('text.apmPages.chooseDate')"
                                                      :button-now-translation="$t('text.globals.now')"
                                />
                            </div>
                        </div>


                        <div class="row mt-3" id="wrapper">
                            <div class="col-md-6">
                                <div id="chart-line" class="mt-3">
                                    <label for="transaction-duration">{{$t('text.apmPages.transactionDuration')}}</label>
                                    <apexchart id="transaction-duration" type=line height="300"
                                               :options="transactionDurationChartOptions"
                                               :series="transactionDurationSeries"
                                               :key="transactionDurationDataLoaded"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div id="chart-line2" class="mt-3">
                                    <label for="requests-per-minute">{{$t('text.apmPages.requestsPerMinute')}}</label>
                                    <apexchart id="requests-per-minute" type=line height="300"
                                               :options="requestsPerMinuteChartOptions"
                                               :series="requestsPerMinuteSeries"
                                               :key="requestsPerMinuteDataLoaded"/>
                                </div>
                            </div>
                        </div>

                    </div>


                </div>


            </div>

        </main>

    </div>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faHome} from '@fortawesome/free-solid-svg-icons'
    import SidebarNavigation from '../components/SidebarNavigation';
    import {VueGoodTable} from 'vue-good-table';
    import axios from 'axios/index';

    library.add(faHome);


    export default {
        name: 'Transaction Group',
        components: {
            SidebarNavigation
        },
        data() {
            return {
                startTimestamp: null,
                endTimestamp: null,
                startTimeDate: null,
                endTimeDate: null,
                transactionDurationDataLoaded: false,
                requestsPerMinuteDataLoaded: false,
                transactionDurationSeries: [],
                requestsPerMinuteSeries: [],

                transactionDurationChartOptions: {
                    colors: ['#3185fc', '#e6c220', '#f98510'],

                    chart: {
                        group: 'transactionData',
                        id: 'transactionDuration'
                    },
                    xaxis: {
                        type: "datetime"
                    },
                    yaxis: {
                        labels: {
                            formatter: function (value) {
                                return Math.round(value / 1000) + " ms";
                            },
                            minWidth: 0
                        },

                    },
                    stroke: {
                        width: 3
                    },
                    legend: {
                        position: 'bottom',
                        onItemClick: {
                            toggleDataSeries: true
                        },
                    },
                    noData: {
                        text: this.$t('text.apmPages.transactionGroup.noDataForSelectedTimeFrame'),
                        align: 'center',
                        verticalAlign: 'middle',
                        offsetX: 0,
                        offsetY: 0,
                        style: {
                            color: '#c2c2c2',
                            fontSize: '18px',
                            fontFamily: 'Open Sans'
                        }
                    }
                },
                requestsPerMinuteChartOptions: {
                    colors: ['#00b3a4', '#f98510', '#db1374'],

                    chart: {
                        group: 'transactionData',
                        id: 'requestsPerMinute'
                    },
                    xaxis: {
                        type: "datetime"
                    },
                    yaxis: {
                        labels: {
                            formatter: function (value) {
                                return Math.round(value) + " rpm";
                            },
                            minWidth: 0
                        },

                    },
                    stroke: {
                        width: 3
                    },
                    legend: {
                        position: 'bottom',
                        onItemClick: {
                            toggleDataSeries: true
                        },
                    },
                    noData: {
                        text: this.$t('text.apmPages.transactionGroup.noDataForSelectedTimeFrame'),
                        align: 'center',
                        verticalAlign: 'middle',
                        offsetX: 0,
                        offsetY: 0,
                        style: {
                            color: '#c2c2c2',
                            fontSize: '18px',
                            fontFamily: 'Open Sans'
                        }
                    }
                },
                //table
                columns: [
                    {
                        label: this.$t('text.apmPages.tableColumns.serviceName'),
                        field: 'name',
                        type: 'text',
                        sortable: true
                    },
                    {
                        label: this.$t('text.apmPages.tableColumns.avgDuration'),
                        field: 'averageResponseTime',
                        type: 'text',
                        sortable: true,
                        formatFn: this.formatMiliseconds,
                    },
                    {
                        label: this.$t('text.apmPages.tableColumns.p95'),
                        field: 'p95',
                        type: 'text',
                        sortable: true,
                        formatFn: this.formatMiliseconds,
                    },
                    {
                        label:  this.$t('text.apmPages.tableColumns.transactionsPerMinute'),
                        field: 'transactionsPerMinute',
                        type: 'text',
                        sortable: true,
                        formatFn: this.formatTransactionsPerMinute,
                    },
                    {
                        label: this.$t('text.apmPages.tableColumns.impact'),
                        field: 'impact',
                        type: 'text',
                        sortable: true,
                    }
                ],
                rows: [],
                breadcrumbItems: [
                    {
                        text: this.$t('text.apmPages.apmLabel'),
                        href: '#/apm'
                    },
                    {
                        text: this.$route.params.serviceName,
                        href: '#/transactions/' + encodeURIComponent(this.$route.params.serviceName)
                    },
                    {
                        text: this.$t('text.apmPages.transactionsLabel'),
                        href: '#/transactions/' + encodeURIComponent(this.$route.params.serviceName)
                    },
                    {
                        text: this.$route.params.transactionGroup,
                        href: '#/transactions/' + encodeURIComponent(this.$route.params.serviceName) + '/' + encodeURIComponent(this.$route.params.transactionGroup),
                        active: true
                    }
                ]
            }
        },
        mounted() {
            this.initDate();
        },

        watch: {
            '$route'(to, from) {
                // react to route changes...


                this.initDate();


            }

        },

        methods: {

            updateTimes(){

                this.$router.push({
                    path: "",
                    query:{
                        start: encodeURIComponent(this.startTimestamp),
                        end: encodeURIComponent(this.endTimestamp)
                    }
                });


            },

            getData() {
                this.transactionDurationDataLoaded = false;
                this.requestsPerMinuteDataLoaded = false;



                console.log("cas zacetka: ", this.startTimestamp);
                console.log("cas konca: ", this.endTimestamp);

                axios.get(config.kibana + this.$route.params.serviceName + "/transaction_groups/charts?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp) + "&transactionName=" + encodeURIComponent(this.$route.params.transactionGroup) + "&uiFilters=%7B%7D" + "&transactionType=request", {headers: {}})
                    .then((res) => {

                        // transaction duration graf
                        console.log("response za transaction duration graf:", res.data);
                        this.transactionDurationSeries[0] = {data: [], name: this.$t('text.apmPages.average')};
                        this.transactionDurationSeries[1] = {data: [], name: this.$t('text.apmPages.ninetyFifthPercentile')};
                        this.transactionDurationSeries[2] = {data: [], name: this.$t('text.apmPages.ninetyNinthPercentile')};
                        this.transactionDurationSeries[0].data = res.data.apmTimeseries.responseTimes.avg;
                        this.transactionDurationSeries[1].data = res.data.apmTimeseries.responseTimes.p95;
                        this.transactionDurationSeries[2].data = res.data.apmTimeseries.responseTimes.p99;
                        this.transactionDurationDataLoaded = true;
                        console.log("transactionDurationSeries", this.transactionDurationSeries);

                        // requests per minute graf

                        for (var i = 0; i < res.data.apmTimeseries.tpmBuckets.length; i++) {
                            this.requestsPerMinuteSeries[i] = {
                                name: res.data.apmTimeseries.tpmBuckets[i].key,
                                data: res.data.apmTimeseries.tpmBuckets[i].dataPoints,
                            }
                        }
                        this.requestsPerMinuteDataLoaded = true;
                        console.log("requestsPerMinuteSeries", this.requestsPerMinuteSeries);


                    })
                    .catch((error) => {
                        console.log(error);
                    });


                //tabela
                axios.get(config.kibana + this.$route.params.serviceName + "/transaction_groups/distribution?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp) + "&transactionName=" + encodeURIComponent(this.$route.params.transactionGroup) + "&uiFilters=%7B%7D" + "&transactionType=request", {headers: {}})
                    .then((res) => {
                        console.log("response za tabelo:", res.data);
                        this.rows = res.data;
                    })
                    .catch((error) => {
                        console.log(error);
                    });

            },

            initDate() {

                if (this.$route.query.start == null && this.$route.query.end == null) {
                    this.endTimeDate = new Date();
                    this.startTimeDate = new Date();
                    this.startTimeDate.setDate(this.endTimeDate.getDate() - 1);
                    this.startTimestamp = this.startTimeDate.toISOString();
                    this.endTimestamp = this.endTimeDate.toISOString();

                    this.$router.push({
                        path: "",
                        query:{
                            start: encodeURIComponent(this.startTimestamp),
                            end: encodeURIComponent(this.endTimestamp)
                        }
                    });

                } else {

                    this.startTimestamp = decodeURIComponent(this.$route.query.start);
                    this.endTimestamp = decodeURIComponent(this.$route.query.end);


                }

                this.breadcrumbItems[0].href = "#/apm/?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp);
                this.breadcrumbItems[1].href = "#/transactions/" + encodeURIComponent(this.$route.params.serviceName) + "?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp);
                this.breadcrumbItems[2].href = "#/transactions/" + encodeURIComponent(this.$route.params.serviceName) + "?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp);
                this.getData();
            },

            formatMiliseconds(value) {
                return Math.round(value / 1000) + " " + this.$t('text.apmPages.ms');
            },

            formatTransactionsPerMinute(value) {
                return +parseFloat(value).toFixed(1) + " " + this.$t('text.apmPages.tpm');
            },

            onCellClick(params) {
                console.log(params);
            }

        },
        beforeCreate: function () {
            document.body.className = 'transactions';
        }
    };
</script>



// WEBPACK FOOTER //
// src/pages/TransactionGroup.vue